import { jsx as e } from "react/jsx-runtime";
function r(l) {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...l,
      children: /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.98859 0C4.04487 0 0 4.04486 0 8.98859C0 13.9323 4.04487 17.9772 8.98859 17.9772C13.9323 17.9772 17.9772 13.9323 17.9772 8.98859C17.9772 4.04487 13.9323 0 8.98859 0ZM8.98859 2.24715C10.4717 2.24715 11.82 2.71902 12.9211 3.50552L3.50555 12.9211C2.71906 11.8199 2.24718 10.4716 2.24718 8.98855C2.24718 5.25829 5.2584 2.24711 8.98862 2.24711L8.98859 2.24715ZM14.4716 5.05608C15.2581 6.15721 15.73 7.5055 15.73 8.98859C15.73 12.7188 12.7188 15.73 8.98855 15.73C7.50546 15.73 6.15718 15.2582 5.05605 14.4717L14.4716 5.05608Z"
        }
      )
    }
  );
}
export {
  r as BlockedIcon
};
